// extracted by mini-css-extract-plugin
module.exports = {"social":"social__WM6t0","icon":"icon__SvjZJ"};